import Grid from "@mui/material/Grid2";
import { useFormContext } from "../../../core/form/IForm";
import { ICore } from "../../../core/ICore";

const hourOptions = [
  { key: 0, value: "0" },
  { key: 1, value: "1" },
  { key: 2, value: "2" },
];
const minOptions = Array.from({ length: 61 }, (_, i) => ({
  key: i,
  value: i.toString().padStart(2, "0"),
}));

const TradeConfiguration = () => {
  const form = useFormContext();
  const runProcessType = form?.values?.runProcessType || "";
  const isSchedule = runProcessType === "Scheduled";

  return (
    <Grid container flexDirection="row" spacing={2} sx={{ minWidth: { xs: 0, sm: 320 } }}>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <ICore.IToggle model="statergyType" label="Strategy Type" lookup="TradingMode" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <ICore.ITextBox model="availableBudget" label="Available Balance" type="number" />
      </Grid>
      <Grid size={{ xs: 6, sm: 6, md: 6 }}>
        <ICore.ITextBox model="tradeBudget" label="Trade Budget" type="number" />
      </Grid>
      <Grid size={{ xs: 6, sm: 6, md: 6 }}>
        <ICore.ITextBox model="budgetPerTrade" label="Budget Per Trade" type="number" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <ICore.IToggle model="tradeType" label="Trade Type" lookup="TradingType" />
      </Grid>
      <Grid size={{ xs: 6, sm: 3, md: 3 }}>
        <ICore.ITextBox model="stopProfit" label="Stop Profit%" type="number" />
      </Grid>
      <Grid size={{ xs: 6, sm: 3, md: 3 }}>
        <ICore.ITextBox model="stopLoss" label="Stop Loss%" type="number" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <ICore.IToggle model="runProcessType" label="Run Process Type" lookup="RunProcessType" />
      </Grid>
      {isSchedule && (
        <>
          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
            <ICore.ISelectBox model="scheduleHour" label="Hour" options={hourOptions} />
          </Grid>
          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
            <ICore.ISelectBox model="scheduleMin" label="Min" options={minOptions} />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default TradeConfiguration;
